import { AlphaICircleIcon } from './AlphaICircleIcon';

/**
 * author: Contributors
 * id 0CAD67D2-EFF3-442E-91D6-1C27D759C1DD
 * name alpha-i-circle
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-i-circle.svg
 * tags
 * - Alpha / Numeric 
 */
export const LetterICircleIcon = AlphaICircleIcon;
export default LetterICircleIcon